module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av340-6205976f0c9328e58b778c88f53f8173.jpg";